// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import MaterialAutocompleteController from "./material_autocomplete_controller"
application.register("material-autocomplete", MaterialAutocompleteController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import InlineEditController from "./inline_edit_controller"
application.register("inline-edit", InlineEditController)

import LightboxController from "./lightbox_controller"
application.register("lightbox", LightboxController)

import RecordAutocompleteController from "./record_autocomplete_controller"
application.register("record-autocomplete", RecordAutocompleteController)

import UserAutocompleteController from "./user_autocomplete_controller"
application.register("user-autocomplete", UserAutocompleteController)

import AutosaveController from "./autosave_controller"
application.register("autosave", AutosaveController)
